import http from 'plugins/axios';

export default {
  getRecords(data) {
    return http.get({
      url: '/admin/foundation/foundationOrders',
      data
    });
  }
};
